import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[#E2F8FE] to-white border-t-4 border-[#FF4A2A]">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <img src="/assets/img/brand/logo-dark.png" alt="Trusted Trademark Filer" className="h-12 mb-4" />
            <p className="text-base text-gray-700 leading-relaxed">
              Professional trademark registration and intellectual property protection services for businesses of all sizes.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-base text-gray-700 hover:text-[#FF4A2A] transition-colors flex items-center gap-2">
                  <span className="text-[#FF4A2A]">→</span> Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-base text-gray-700 hover:text-[#FF4A2A] transition-colors flex items-center gap-2">
                  <span className="text-[#FF4A2A]">→</span> About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-base text-gray-700 hover:text-[#FF4A2A] transition-colors flex items-center gap-2">
                  <span className="text-[#FF4A2A]">→</span> Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-base text-gray-700 hover:text-[#FF4A2A] transition-colors flex items-center gap-2">
                  <span className="text-[#FF4A2A]">→</span> Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services/register-trademark" className="text-base text-gray-700 hover:text-[#FF4A2A] transition-colors flex items-center gap-2">
                  <span className="text-[#FF4A2A]">→</span> Trademark Registration
                </Link>
              </li>
              <li>
                <Link to="/services/clearance-search" className="text-base text-gray-700 hover:text-[#FF4A2A] transition-colors flex items-center gap-2">
                  <span className="text-[#FF4A2A]">→</span> Clearance Search
                </Link>
              </li>
              <li>
                <Link to="/services/register-copyright" className="text-base text-gray-700 hover:text-[#FF4A2A] transition-colors flex items-center gap-2">
                  <span className="text-[#FF4A2A]">→</span> Copyright Registration
                </Link>
              </li>
              <li>
                <Link to="/services/patent-search" className="text-base text-gray-700 hover:text-[#FF4A2A] transition-colors flex items-center gap-2">
                  <span className="text-[#FF4A2A]">→</span> Patent Services
                </Link>
              </li>
              <li>
                <Link to="/services/llc-formation" className="text-base text-gray-700 hover:text-[#FF4A2A] transition-colors flex items-center gap-2">
                  <span className="text-[#FF4A2A]">→</span> Company Formation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#FF4A2A] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-base text-gray-700 font-semibold">+1 (888) 203 1471</p>
                  <p className="text-sm text-gray-600">Mon-Fri 9AM-6PM EST</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#FF4A2A] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-base text-gray-700 font-semibold">Info@trustedtrademarkfiler.com</p>
                  <p className="text-sm text-gray-600">24/7 Support</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FF4A2A] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-base text-gray-700">28202 Cabot Rd #300</p>
                  <p className="text-base text-gray-700">Laguna Niguel, CA 92677</p>
                  <p className="text-base text-gray-700">United States</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-white border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600">
              © 2026 Trusted Trademark Filer. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/privacy-policy"
                className="text-sm text-gray-600 hover:text-[#FF4A2A] transition-colors"
              >
                Privacy Policy
              </Link>
              <span className="text-gray-400">|</span>
              <Link
                to="/terms-of-service"
                className="text-sm text-gray-600 hover:text-[#FF4A2A] transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;